module.exports = __webpack_public_path__ + "img/approve.c7028739.svg";